import React, { useState } from 'react'
import { CBadge, CFormSwitch, CSmartTable } from '@coreui/react-pro'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import AdsManagerService from 'src/service/AdsManagerService'
import { PLACEMENT_OPTIONS } from './promoFormConfig'

const formatDate = (value) => (value ? moment(value).format('D.MM.YYYY') : '—')

const placementLabel = (value) =>
  PLACEMENT_OPTIONS.find((option) => option.value === value)?.text || value

const GamePromoTable = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  itemsPerPage,
  activePage,
  loading,
}) => {
  const API_URL = process.env.REACT_APP_API_URL
  const [updatingId, setUpdatingId] = useState(null)

  // gameAdsListing only filters on `title` and orders by the saved display order, so the
  // remaining columns stay display-only instead of offering controls the API ignores.
  const columns = [
    {
      label: 'Logo',
      key: 'logo',
      _style: { width: '8%' },
      filter: false,
      sorter: false,
    },
    { label: 'Promo Title', key: 'title', sorter: false },
    { label: 'Promo Label', key: 'promo_label', filter: false, sorter: false },
    { label: 'Placement', key: 'placement', filter: false, sorter: false },
    { label: 'Validity', key: 'validity_date', filter: false, sorter: false },
    { label: 'Start Date', key: 'schedule_start_date', filter: false, sorter: false },
    { label: 'End Date', key: 'schedule_end_date', filter: false, sorter: false },
    {
      label: 'Show in Game',
      key: 'is_active',
      _style: { width: '12%' },
      filter: false,
      sorter: false,
    },
  ]

  const handleStatus = (id, status) => {
    setUpdatingId(id)
    AdsManagerService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        } else {
          ToastComponent(res.message, 'error')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
      .finally(() => {
        setUpdatingId(null)
      })
  }

  const totalPages = Math.ceil((users?.total || 0) / itemsPerPage)
  const showPagination = totalPages > 1

  return (
    <div className="ge-datatable ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        scopedColumns={{
          logo: (item) => (
            <td>
              {item.logo ? (
                <img
                  src={`${API_URL}uploads/ads/${item.logo}`}
                  alt="promo"
                  width="40"
                  height="40"
                  className="rounded"
                />
              ) : (
                <span className="text-medium-emphasis">—</span>
              )}
            </td>
          ),
          title: (item) => (
            <td>
              <span className="fw-semibold">{item.title}</span>
            </td>
          ),
          promo_label: (item) => (
            <td>{item.promo_label || <span className="text-medium-emphasis">—</span>}</td>
          ),
          placement: (item) => {
            const placements = Array.isArray(item.placement) ? item.placement : []
            return (
              <td>
                {placements.length ? (
                  <div className="d-flex flex-wrap gap-1">
                    {placements.map((value) => (
                      <CBadge color="primary" shape="rounded-pill" key={value}>
                        {placementLabel(value)}
                      </CBadge>
                    ))}
                  </div>
                ) : (
                  <span className="text-medium-emphasis">—</span>
                )}
              </td>
            )
          },
          validity_date: (item) => <td>{formatDate(item.validity_date)}</td>,
          schedule_start_date: (item) => <td>{formatDate(item.schedule_start_date)}</td>,
          schedule_end_date: (item) => <td>{formatDate(item.schedule_end_date)}</td>,
          is_active: (item) => (
            <td>
              <CFormSwitch
                id={`promo_status_${item.id}`}
                label={item.is_active === 1 ? 'Activated' : 'Deactivated'}
                checked={item.is_active === 1}
                disabled={updatingId === item.id}
                onChange={(e) => handleStatus(item.id, e.target.checked ? 1 : 0)}
              />
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={showPagination ? { external: true } : false}
        paginationProps={
          showPagination
            ? {
                activePage: activePage,
                pages: totalPages,
              }
            : undefined
        }
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
      />
    </div>
  )
}

export default GamePromoTable
